import { render, staticRenderFns } from "./chartVisitorWeeks.vue?vue&type=template&id=0d2256c9&scoped=true&"
import script from "./chartVisitorWeeks.vue?vue&type=script&lang=js&"
export * from "./chartVisitorWeeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2256c9",
  null
  
)

export default component.exports